import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    FormControlLabel,
    FormGroup,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tooltip,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useMutateAutoNumberingHandler } from '../dataHandlers/mutateAutoNumberingHandler';
import { fetchOrgRequest } from '../../../api/organizations/orgSlice';
import {useMutateMFASettingHandler} from "../dataHandlers/mutateMFASettingHandler";

const MFASettingSection = () => {
    const dispatch = useDispatch();
    const { settings } = useSelector((state) => state.org.org);

    const onSuccess = () => {
        dispatch(fetchOrgRequest());
    };

    const { onSubmit } = useMutateMFASettingHandler({ onSuccess });

    const handleSubmit = async (mfaEnabledStatus) => {
        await onSubmit({ is_mfa_enabled: mfaEnabledStatus });
    };

    return (
        <Paper elevation={0} sx={{ pl: '1rem' }}>
            <Grid container>
                <Grid size={6}>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={settings?.account_settings?.is_mfa_enabled}
                                    onChange={() => {
                                        handleSubmit(!settings?.account_settings?.is_mfa_enabled);
                                    }}
                                />
                            }
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {"Email-based two-factor authentication (2FA)"}
                                    <Tooltip title={"Require users to provide a verification code sent to their email address each time they sign in for added security."}>
                                        <IconButton size="small">
                                            <InfoOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            }
                            labelPlacement="start"
                            sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
                        />
                    </FormGroup>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default MFASettingSection;
